/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Modal, Radio, Input, Button, Tooltip, message } from "antd";
import { handleManualEntryDateValidation } from "../features/helperFunctions";
import { BsInfoLg } from "react-icons/bs";
import { amendExtendContractTypes, counterOfferContractTypes, createOfferContractTypes, createOfferInitialState, noChangeCheckboxContractTypes } from "../../Common/commondata/commonData";
import styles from "../../DocumentSection/styles/offerImport.module.css";
import { getAttr, handleShowPicker } from "../../Common/utils/universalFuntions";

const ModifyDatesModal = ({ modalState, setModalState, handleInputSave, currentUrlId, rootDocData, source }) => {
  const [formState, setFormState] = useState({
    radioType: "date",
    inputValue: "",
  });
  const hanInputChanged = useRef(null);
  const isXBtnClicked = useRef(false);

  const handleCancel = () => {
    setModalState({ ...createOfferInitialState });
  };

  useEffect(() => {
    const elements = document.querySelectorAll("input[type='date'], input[type='time']");
    elements?.forEach((element) => {
      element.addEventListener("click", handleShowPicker);
    });

    // return () => {
    //   elements?.forEach((element) => {
    //     element.removeEventListener("click", handleShowPicker);
    //   });
    // };
  }, []);

  const isRelativeTime = modalState?.event?.target?.classList?.contains("relativeTimeInput");
  const isClosingDateField = modalState?.event?.target?.classList?.contains("closing-date-input") || ["OriginalContractDate", "ClosingDate", "DocumentDate", "ERTSOriginalContractDate"].includes(modalState?.event?.target?.name);
  const requiredDateField = modalState?.event?.target?.classList?.contains("requiredDateInput");

  useEffect(() => {
    const isRelativeTime = modalState?.event?.target?.classList?.contains("relativeTimeInput");
    const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    const inputName = modalState.event?.target?.name;
    const currentData = localData[inputName];
    if (currentData) {
      if (!isNaN(Date.parse(currentData))) {
        setFormState({
          radioType: "date",
          inputValue: currentData,
        });
      } else if (currentData?.type) {
        setFormState({
          radioType: currentData.type,
          inputValue: currentData.value,
        });
      } else if (isRelativeTime) {
        setFormState({
          radioType: "time",
          inputValue: currentData,
        });
      }
    } else {
      setFormState({
        radioType: "date",
        inputValue: "",
      });
    }
  }, [currentUrlId, modalState.event?.target?.name]);

  const handleDataChange = ({ formattedData }) => {
    const inputName = modalState.event?.target?.name;
    let currentUrlIdData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    currentUrlIdData[inputName] = formattedData;
    let specificaData = { [inputName]: formattedData };
    // to select other target checkboxes
    if (modalState.event.target.hasAttribute("data-enable-target")) {
      document.querySelectorAll(`[data-enable-source="${modalState.event.target.dataset.enableTarget}"]`).forEach((element) => {
        element.checked = true;
        specificaData[element.name] = element.value;
        currentUrlIdData[element.name] = element.value;
      });
    }
    localStorage.setItem(currentUrlId, JSON.stringify(currentUrlIdData));
    handleInputSave(specificaData);
    handleCancel();
  };

  const handleSave = () => {
    const { radioType, inputValue } = formState;
    const inputName = modalState.event?.target?.name;
    if (!inputName) {
      console.error("No input name found");
      return;
    }
    if (radioType === "date" && source !== "OFFER_IMPORT") {
      handleManualEntryDateValidation({ event: modalState.event, isClosingDateField, currentUrlId, handleInputSave, radioType, inputValue, handleDataChange, rootDocData });
      return;
    }
    let relation = "";
    if (["OCD"].includes(radioType) && inputValue) {
      if (Number(inputValue) === 0) {
        relation = "Same as Contract Date";
      } else if (Number(inputValue) > 0) {
        relation = `${Number(inputValue) === 1 ? "day" : "days"} after Contract Date`;
      } else if (Number(inputValue) < 0) {
        relation = `${Math.abs(Number(inputValue)) === 1 ? "day" : "days"} before Contract Date`;
      }
    }

    let formattedData = {
      type: inputValue ? radioType : "text",
      value: inputValue ? inputValue : [...noChangeCheckboxContractTypes, "ET"].includes(rootDocData?.contractType) || (source === "OFFER_IMPORT" && isClosingDateField) ? "" : "N/A",
      ...(radioType === "mec" && { calculatedDate: "" }),
      ...(["OCD"].includes(radioType) && { calculatedDate: "", relation }),
    };

    if (source === "OFFER_IMPORT" && requiredDateField && !inputValue) {
      message.error("Please select a valid date.");
      return;
    }
    if (isClosingDateField) formattedData = formattedData.value;
    handleDataChange({ formattedData });
    isXBtnClicked.current = false;
  };

  const onChangeRadio = (e) => {
    setFormState({ radioType: e.target.value, inputValue: "" });
  };

  const onChangeInput = (e) => {
    const { value } = e.target;
    //  Preventing negative and non-numeric input for MEC
    if (["mec", "OCD"].includes(formState.radioType) && (!/^\d*$/.test(value) || value < 0 || value > 500)) {
      return;
    }
    setFormState((prevState) => ({ ...prevState, inputValue: value }));
    hanInputChanged.current = true;
  };

  const inputProps = (type) => ({
    name: modalState.event?.target?.name,
    value: formState.radioType === type ? formState.inputValue : "",
    onChange: onChangeInput,
    onClick: () => {
      if (formState.radioType !== type) {
        setFormState({ radioType: type, inputValue: "" });
      }
    },
  });
  let relativeDateModalTile = getAttr(modalState?.event, "data-relative-modal-title");
  let labelText = [...createOfferContractTypes, ...counterOfferContractTypes, "ET", "SSA_CBS", "MHA_CBS", ...amendExtendContractTypes].includes(rootDocData?.contractType) ? modalState?.event?.target?.parentElement?.previousElementSibling?.textContent || (isRelativeTime ? "Select Time" : "Select Date") : isRelativeTime ? "Select Time" : "Select Date";

  if (source === "OFFER_IMPORT") {
    const label = modalState?.event?.target?.parentElement?.querySelector(`.${styles.Customlbl}`);
    labelText = label?.textContent?.trim().replace(/^\*\s*/, "") || (isRelativeTime ? "Select Time" : "Select Date");
  }

  return (
    <Modal
      visible={true}
      width={"600px"}
      title={
        <div
          className="commonModalTitle"
          style={{
            width: "90%",
            overflow: "elipsis",
          }}
        >
          {relativeDateModalTile || labelText}
        </div>
      }
      closeIcon={
        <span 
        onClick={() => {
          isXBtnClicked.current = true
          handleCancel()
        }}
        >X</span>
      }
      onCancel={() => {
        if(hanInputChanged.current && !isXBtnClicked.current){
          handleSave()
        }
        isXBtnClicked.current = false;
        handleCancel()
      }}
      footer={null}
    >
      <div style={{ height: "fit-content", overflowY: "auto", overflowX: "hidden" }}>
        <div style={{ display: "flex", maxWidth: "400px", flexDirection: "column", gap: "20px" }}>
          <Radio.Group onChange={onChangeRadio} value={formState.radioType}>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", width: "400px" }}>
              {isRelativeTime && rootDocData?.builtForSection !== "TEMPLATE" && rootDocData?.builtForSection !== "DOCUMENT_SET" && (
                <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                  <Radio value="time">Select Time</Radio>
                  <Input type="time" {...inputProps("time")} style={{ width: "148px", marginLeft: "-5px" }} />
                </div>
              )}
              {!isRelativeTime && rootDocData?.builtForSection !== "TEMPLATE" && rootDocData?.builtForSection !== "DOCUMENT_SET" && (
                <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                  <Radio value="date">Select Date</Radio>
                  <Input type="date" {...inputProps("date")} style={{ width: "150px", marginLeft: "-5px" }} />
                </div>
              )}
              {!isRelativeTime && !isClosingDateField && ([...createOfferContractTypes, "SSA_CBS", ...counterOfferContractTypes].includes(rootDocData?.contractType) || source === "OFFER_IMPORT") && (
                <Radio value="mec">
                  <Input type="text" {...inputProps("mec")} style={{ margin: "5px", width: "70px" }} /> Days After MEC
                </Radio>
              )}
              {!isRelativeTime && !isClosingDateField && rootDocData?.builtForSection === "TEMPLATE" && [...createOfferContractTypes, ...counterOfferContractTypes].includes(rootDocData?.contractType) && (
                <Radio value="OCD">
                  <Input type="text" {...inputProps("OCD")} style={{ margin: "5px", width: "70px" }} /> Days After Contract Date
                </Radio>
              )}
              {!isClosingDateField && (
                <Radio value="text" style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <Input placeholder="Enter text" maxLength={30} {...inputProps("text")} style={{ margin: "5px", width: "230px" }} />
                    {[...createOfferContractTypes, ...counterOfferContractTypes, "ET", ...amendExtendContractTypes].includes(rootDocData?.contractType) && !isRelativeTime && (
                      <Tooltip title={"RE-Sure is not able to build Calendar reminders if you choose this option."} placement="right">
                        <BsInfoLg style={{ fontSize: "35px" }} />
                      </Tooltip>
                    )}
                  </div>
                </Radio>
              )}
            </div>
          </Radio.Group>
        </div>
        <div style={{ textAlign: "center", margin: "40px 30px 30px 30px" }}>
          <Button type="primary" onClick={handleSave} disabled={!hanInputChanged.current}>
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModifyDatesModal;
